/* src/app/order/components/transfer-documents/transfer-documents-group/transfer-documents-group.style.scss */
.transfer-documents-panel nb-card-body {
  padding-left: 16px;
}
.transfer-documents-panel .question-green {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 20px;
}
.transfer-documents-panel .input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.transfer-documents-panel .file-button {
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 0.75rem;
  cursor: pointer;
  border-color: #007d40;
  background-color: #f7fbfc;
  border-width: 0.075rem;
  border-style: solid;
  color: #007d40;
  padding: 0.25rem 0.625rem;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
}
.transfer-documents-panel .file-button .button-icon {
  margin-left: 10px;
  cursor: pointer;
}
.transfer-documents-panel .file-button.details {
  cursor: default;
  margin-bottom: 20px;
  margin-right: 12px;
  color: #007d40;
  border-color: #585858;
  background-color: white;
  font-weight: normal;
  font-size: 0.725rem;
}
.transfer-documents-panel .explanation-text {
  font-size: 12px;
  color: #8C8C8C;
  margin-bottom: 15px;
}
/*# sourceMappingURL=transfer-documents-group.style.css.map */
